import { form } from "./form";

const {
  formField: { rooms, notes, endpointUrl },
} = form;

const initialValues = {
  [endpointUrl.name]: [],
  [rooms.name]: [],
  [notes.name]: "",
};

export default initialValues;
